import { BaseFieldRenderer } from './base-field-renderer';
import { DateFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class DateFieldRenderer extends BaseFieldRenderer<DateFieldJsonData> {
    protected override get defaultData(): DateFieldJsonData {
        return {
            id: '',
            type: 'date',
            label: TranslateUtils.DATE_FIELD.LABEL,
            description: '',
            format: TranslateUtils.DATE_FIELD.FORMAT,
            fillCurrentDate: false,
            required: false,
            hiddenLabel: false
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: DateFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 11;
        input.dataset['format'] = fieldJsonData.format || TranslateUtils.DATE_FIELD.FORMAT;
        input.dataset['fillCurrentDate'] = String(fieldJsonData.fillCurrentDate ?? false);

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
